/* istanbul ignore file */
import { getEnvVars } from '@order/utils';

/**
 * Returns the slug for the restaurant the kiosk resides in.
 *
 * Currently pulls this from .env variables, though the long-term goal is to manage this via MDM
 */
export function getKioskRestaurantSlug() {
  const { KIOSK_RESTAURANT_SLUG } = getEnvVars();

  return String(KIOSK_RESTAURANT_SLUG);
}

/**
 * Returns the default first name for a kiosk guest
 */
export function getKioskGuestDefaultFirstName() {
  const { KIOSK_GUEST_DEFAULT_FIRST_NAME } = getEnvVars();

  return String(KIOSK_GUEST_DEFAULT_FIRST_NAME);
}

/**
 * Returns the default last name for a kiosk guest
 */
export function getKioskGuestDefaultLastName() {
  const { KIOSK_GUEST_DEFAULT_LAST_NAME } = getEnvVars();

  return String(KIOSK_GUEST_DEFAULT_LAST_NAME);
}

/**
 * Returns the default email for a kiosk guest
 */
export function getKioskGuestDefaultEmail() {
  const { KIOSK_GUEST_DEFAULT_EMAIL } = getEnvVars();

  return String(KIOSK_GUEST_DEFAULT_EMAIL);
}

/**
 * Returns the device auth username for kiosks
 */
export function getDeviceAuthUsername() {
  const { KIOSK_DEVICE_AUTH_USERNAME } = getEnvVars();

  return String(KIOSK_DEVICE_AUTH_USERNAME);
}

/**
 * Returns the device auth password for kiosks
 */
export function getDeviceAuthPassword() {
  const { KIOSK_DEVICE_AUTH_PASSWORD } = getEnvVars();

  return String(KIOSK_DEVICE_AUTH_PASSWORD);
}

/**
 * Returns the device auth url for kiosks
 */
export function getDeviceAuthUrl() {
  const { KIOSK_DEVICE_AUTH_URL } = getEnvVars();

  return String(KIOSK_DEVICE_AUTH_URL);
}
